﻿import Image from "../image";
import ActivePage from "../activePage";

export default class DisclosurePage extends ActivePage {

    constructor() {
        super();
        this.image = new Image();
        this.showOutstandingActionsOnly = true;

        this.checkWorkflowActions = false;
        this.workflowTriggerType = "";
    }

    init(screen) {
        $(document).ready(() => {
            //TN 20221116
            let mainForm = $(`#${this.mainDetailContainer}`).find("form")[0];
            mainForm = $(mainForm);
            //TN 20221116

            const inventorsGrid = $(`#inventorsGrid_${screen}`);
            inventorsGrid.on("click", ".inventorLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = inventorsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.InventorDetail.InventorID);

                //TN 20221116                  
                const submitMessage = mainForm.data("eu-policy");
                const submitTitle = mainForm.data("eu-title");
                cpiConfirm.confirm(submitTitle, submitMessage, function () {
                    pageHelper.openLink(linkUrl, false);
                });
                //TN 20221116
            });

            //TN 20221116
            //const atty = this.getKendoComboBox("AttorneyID");
            //$("input[name='ClientID']").change(function () {
            //    const baseUrl = $("body").data("base-url");
            //    $.ajax({
            //        url: `${baseUrl}/Shared/Client/GetPatDefaultAttorney`,
            //        data: { clientId: this.value },
            //        dataType: 'json',
            //        success: function (data) {
            //            if (data.length > 0) {
            //                if (atty.value() == '' && data[0].PatAttorney1ID != null) {
            //                    atty.value(data[0].PatAttorney1ID);
            //                    atty.element.trigger("change");
            //                }
            //            }
            //        }
            //    });
            //})
            //TN 20221116

            const actionsGrid = $(`#actionsGrid_${screen}`);
            actionsGrid.on("click", ".action-link", (e) => {
                e.stopPropagation();
                e.preventDefault();

                if (this.actionActIds && this.actionActIds.length > 0) {
                    dmsActionDuePage.mainSearchRecordIds = this.actionActIds;
                }
                const link = $(e.target);
                pageHelper.openDetailsLink(link);
            });

            //TN 20221116
            const productsGrid = $(`#productsGrid_${screen}`);
            productsGrid.on("click", ".productLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = productsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.ProductId);
                pageHelper.openLink(linkUrl, false);
            });

            const componentsGrid = $(`#componentsGrid_${screen}`);
            componentsGrid.on("click", ".componentLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = componentsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.ComponentID);
                pageHelper.openLink(linkUrl, false);
            });

            const atty = this.getKendoComboBox("AttorneyID");
            const client = this.getKendoComboBox("ClientID");

            const businessUnit = this.getKendoComboBox("BusinessUnitID");
            const product = this.getKendoComboBox("ProductId");

            const el = mainForm.find("input[name = 'RespOffice']");
            const respOffice = el.data("kendoMultiColumnComboBox");

            $("input[name='ProductId']").change(function () {
                const baseUrl = $("body").data("base-url");
                $.ajax({
                    url: `${baseUrl}/Shared/Product/GetDMSDefaultAttyClient`,
                    data: { productId: this.value, businessUnitId: businessUnit.value() },
                    dataType: 'json',
                    success: function (data) {
                        if (data) {
                            if (data.AttorneyID != null) {
                                if (atty && atty.value() == '') {
                                    atty.value(data.AttorneyID);
                                    atty.element.trigger("change");
                                }
                                else if ($("#AttorneyCode")) {
                                    $("#AttorneyCode").val(data.AttorneyCode);
                                    //$("#AttorneyID_dmsDiclosureDetail_Name").val(data.AttorneyName);
                                    $("#AttorneyID").val(data.AttorneyID);
                                    $("#AttorneyID").trigger("change");
                                    //$("#AttorneyID_dmsDiclosureDetail_Name").trigger("change");
                                }
                            }

                            if (data.ClientID != null) {
                                if (client && client.value() == '') {
                                    client.value(data.ClientID);
                                    client.element.trigger("change");
                                }
                                else if ($("#ClientCode")) {
                                    $("#ClientCode").val(data.ClientCode);
                                    //$("#ClientID_dmsDiclosureDetail_Name").val(data.ClientName);
                                    $("#ClientID").val(data.ClientID);
                                    $("#ClientID").trigger("change");
                                    //$("#ClientID_dmsDiclosureDetail_Name").trigger("change");
                                }
                            }

                            if (data.RespOffice != null) {
                                if (respOffice && respOffice.value() == '') {
                                    respOffice.value(data.RespOffice);
                                    respOffice.element.trigger("change");
                                }
                                else if ($("#RespOffice")) {
                                    $("#RespOffice").val(data.RespOffice);                                    
                                    $("#RespOffice").trigger("change");
                                }
                            }
                        }
                    }
                });
            })

            $("input[name='BusinessUnitID']").change(function () {
                if (product) {
                    const baseUrl = $("body").data("base-url");
                    $.ajax({
                        url: `${baseUrl}/Shared/Product/GetDMSDefaultAttyClient`,
                        data: { productId: product.value(), businessUnitId: this.value },
                        dataType: 'json',
                        success: function (data) {
                            if (data) {
                                if (data.AttorneyID != null) {
                                    if (atty && atty.value() == '') {
                                        atty.value(data.AttorneyID);
                                        atty.element.trigger("change");
                                    }
                                    else if ($("#AttorneyCode")) {
                                        $("#AttorneyCode").val(data.AttorneyCode);
                                        //$("#AttorneyID_dmsDiclosureDetail_Name").val(data.AttorneyName);                                        
                                        $("#AttorneyID").val(data.AttorneyID);
                                        $("#AttorneyID").trigger("change");
                                        //$("#AttorneyID_dmsDiclosureDetail_Name").trigger("change");
                                    }
                                }

                                if (data.ClientID != null) {
                                    if (client && client.value() == '') {
                                        client.value(data.ClientID);
                                        client.element.trigger("change");
                                    }
                                    else if ($("#ClientCode")) {
                                        $("#ClientCode").val(data.ClientCode);
                                        //$("#ClientID_dmsDiclosureDetail_Name").val(data.ClientName);
                                        $("#ClientID").val(data.ClientID);
                                        $("#ClientID").trigger("change");
                                        //$("#ClientID_dmsDiclosureDetail_Name").trigger("change");
                                    }
                                }

                                if (data.RespOffice != null) {
                                    if (respOffice && respOffice.value() == '') {
                                        respOffice.value(data.RespOffice);
                                        respOffice.element.trigger("change");
                                    }
                                    else if ($("#RespOffice")) {
                                        $("#RespOffice").val(data.RespOffice);
                                        $("#RespOffice").trigger("change");
                                    }
                                }
                            }
                        }
                    });
                }
            })
            //TN 20221116
        });
    }

    tabChangeSetListener() {
        $('#disclosureTab a').on('click', (e) => {
            e.preventDefault();
            const tab = e.target.id;
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);
                this.loadTabContent(tab);
            }
        });

        this.disclosureSetListener();
    }

    disclosureSetListener() {
        let form = $("#dmsDiclosureDetail-Content").find("form")[0];
        form = $(form);

        //let triggers = ["ClearanceStatus"];
        //let dateFields = "";
        //triggers.forEach(function (item) {
        //    const field = `,input[name="${item}"]`;
        //    dateFields += field;
        //});

        let triggers = ["DisclosureStatus"];
        let nonDateFields = "";
        triggers.forEach(function (item) {
            const field = `,input[name="${item}"]`;
            nonDateFields += field;
        });

        const self = this;
        $(document).ready(function () {
            //form.find(dateFields.substr(1)).each(function () {
            //    const datePicker = $(this).data("kendoDatePicker");
            //    if (datePicker) {
            //        datePicker.bind("change", function () {
            //            self.computeTaxStartExpiration = true;
            //        });
            //    }
            //});
            form.find(nonDateFields.substr(1)).each(function () {
                $(this).bind("change", function () {
                    self.checkWorkflowActions = true;
                    self.workflowTriggerType = "status";
                });
            });
        });

    }

    //called also after save (update and insert)
    showDetails(id) {
        const self = this;
        pageHelper.showDetails(this, id, function () {
            if (self.checkWorkflowActions) {
                self.checkWorkflowActions = false;
                self.checkDisclosureWorkflow(id, self.workflowTriggerType);
                self.workflowTriggerType = "";
            }
        });
    }

    afterInsert = (result) => {
        const self = this;

        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            self.checkDisclosureWorkflow(id, "status");
        });
    }

    deleteDueDate = (e, grid, deleteActionDuePrompt) => {
        this.deleteGridRow(e, grid);
    }

    loadTabContent(tab) {
        const self = this;

        switch (tab) {
            case "actionTab":
                $(document).ready(() => {
                    const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    $(".grid-options #showOutstandingActionsOnly").prop('checked', this.showOutstandingActionsOnly);
                    if (parseInt(grid.options.dataSource.pageSize) > 0)
                        grid.dataSource.pageSize(grid.options.dataSource.pageSize);
                    else
                        grid.dataSource.read();
                });
                break;

            case "keywordsTab":
                $(document).ready(function () {
                    const grid = $("#keywordsGridDMS").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "disclosureDetailDocumentsTab":
                $(document).ready(() => {
                    this.image.initializeImage(this);
                });
                break;
            case "disclosureDetailRelatedDisclosuresTab":
                $(document).ready(function () {
                    const grid = $("#disclosureRelatedDisclosuresGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "reviewsTab":
                $(document).ready(function () {
                    const grid = $("#reviewsGrid").data("kendoGrid");
                    grid.dataSource.read();
                    //use reviewsGridDataBound to also initialize rating when sorting
                    //.done(function () {
                    //    $("#reviewsGrid").find(".star-rating").rating(disclosureReviewPage.getRatingOptions());
                    //});
                });
                break;

            case "relatedInventionTab":
                $(document).ready(function () {
                    const grid = $("#relatedInventionGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "relatedApplicationTab":
                $(document).ready(function () {
                    const grid = $("#relatedApplicationGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "disclosureDetailDiscussionsTab":
                $(document).ready(function () {
                    const grid = $("#disclosureDiscussionGrid").data("kendoGrid");
                    grid.dataSource.read();
                });
                break;
            case "disclosureDetailCorrespondenceTab":
                $(document).ready(() => {
                    const grid = $(`#docsOutGrid_${this.mainDetailContainer}`).data("kendoGrid");
                    grid.dataSource.read();
                });
                break;

            case "":
                break;
        }

        // questionnaire tab
        const questionTabs = $("#questionTabs").val().split("|").filter(item => item === tab);
        if (questionTabs.length) {
            const gridName = `#${questionTabs[0]}Grid_${this.mainDetailContainer}`;
            const grid = $(gridName).data("kendoGrid");
            grid.dataSource.read();
            //prevent click outside the input box
            grid.table.on("click", ".answer-box", function () {
                return false;
            });
        }

    }

    reviewsGridDataBound(e) {
        //READONLY REVIEWS GRID
        let ratingOptions = disclosureReviewPage.getRatingOptions();
        ratingOptions.displayOnly = true;
        $("#reviewsGrid").find(".star-rating").rating(ratingOptions);
    }

    setSubmitButton(submitTitle, submitMessage) {
        const button = $("#submitDisclosure");
        if (button) {
            button.on("click", (e) => {
                cpiConfirm.confirm(submitTitle, submitMessage, function () {
                    const url = button.data("url");
                    const data = {};
                    data.id = $("#DMSId").val();
                    data.tStamp = $("#tStamp").val();

                    $.ajax({
                        url: url,
                        data: data,
                        type: "POST",
                        headers: { "RequestVerificationToken": $("[name='__RequestVerificationToken']").val() },
                        success: function (result) {
                            disclosurePage.showDetails(data.id);
                            pageHelper.showSuccess(result.success);
                            if (result.checkWorkflow) {
                                disclosurePage.checkDisclosureWorkflow(data.id, "status");
                            }    
                        },
                        error: function (error) {
                            pageHelper.showErrors(error.responseText);
                        }

                    });

                });
            });
        }
    }

    // ------------------------------ inventor logic

    onEditInventor(e) {
        const gridId = e.sender.element[0].id;
        if (e.model.isNew()) {
            //Remove move class on newly added row as we do not want to move record which is not yet saved.
            $("#" + gridId + " tbody").find("tr[data-uid=" + e.model.uid + "]").css({ 'cursor': "default", 'HintHandler': '' });
            $("#" + gridId + " tbody").find("tr[data-uid=" + e.model.uid + "]").removeAttr("onChange");
        }
    }

    inventorGridDataBound = function (e) {
        const gridId = e.sender.element[0].id;
        const grid = $("#" + gridId).data("kendoGrid");
        const data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            const trow = grid.tbody.find("tr[data-uid='" + data[i].uid + "']");
            //window.fely = trow;
            if (!data[i].CanModifyName && !data[i].CanModifyInitials) {
                trow.addClass("read-only");
            }
            else if (!data[i].CanModifyName) {
                trow.children("td.editable-cell.inventor-cell").removeClass("editable-cell");
            }
            else if (!data[i].CanModifyInitials) {
                trow.children("td.editable-cell.initials-cell").removeClass("editable-cell");
            }
            if (data[i].IsDefaultInventor) {
                trow.find(".k-grid-Delete").hide();
            }
            if (data[i].IsNonEmployee) {
                trow.children("td.initials-cell").html("");
            }
        }
    }

    isInventorInitialEditable(dataItem) {
        return dataItem.CanModifyInitials;
    }

    isInventorNameEditable(dataItem) {
        return dataItem.CanModifyName;
    }

    //called on inventor grid's afterSubmit to refresh inventor-based detail page permissions
    refreshDetail = (e) => {      
        disclosurePage.showDetails(this.currentRecordId);
        if (e && e.inventorChanged) {
            disclosurePage.checkDisclosureWorkflow(this.currentRecordId, "inventorchanged");
        }
    }

    //inventor grid delete handler that calls refreshDetail after delete
    //delete button is disabled when grid is dirty
    //if delete is allowed if there are pending updates, it will be lost when refreshDetail is called
    deleteInventorRow(e, grid) {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        this.addMoreKeyFields(dataItem);

        const self = this;
        //pageHelper.deleteGridRow(e, dataItem, function () { self.updateRecordStamps(); });
        pageHelper.deleteGridRow(e, dataItem, function (afterDeleteResult) { self.refreshDetail(afterDeleteResult); });
    }

    // ------------------------------ question logic
    questionGridDataBound = function (e) {
        const gridId = e.sender.element[0].id;
        const grid = $("#" + gridId).data("kendoGrid");
        const data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            const trow = grid.tbody.find("tr[data-uid='" + data[i].uid + "']");
            if (!data[i].CanEdit) {
                trow.children("td.editable-cell.text-answer-cell").removeClass("editable-cell");
                trow.children("td.editable-cell.date-answer-cell").removeClass("editable-cell");
                trow.children("td.editable-cell.yesno-answer-cell")[0].innerHTML = "";
                trow.children("td.editable-cell.yesno-answer-cell").removeClass("editable-cell");
            }
            else {
                if (!data[i].IsAnswerText) {
                    trow.children("td.editable-cell.text-answer-cell").removeClass("editable-cell");
                }
                if (!data[i].IsAnswerDate) {
                    trow.children("td.editable-cell.date-answer-cell").removeClass("editable-cell");
                }
                if (!data[i].IsAnswerYesNo) {
                    trow.children("td.editable-cell.yesno-answer-cell")[0].innerHTML = "";
                    trow.children("td.editable-cell.yesno-answer-cell").removeClass("editable-cell");
                    //trow.children("td.editable-cell.yesno-answer-cell").hide();
                }
            }


        }
    }

    isTextQuestionEditable(dataItem) {
        return dataItem.IsAnswerText;
    }

    isDateQuestionEditable(dataItem) {
        return dataItem.IsAnswerDate;
    }

    isYesNoQuestionEditable(dataItem) {
        return dataItem.IsAnswerYesNo;
    }
        

    refreshDiscussionGrid(e) {
        //const gridId = e.sender.element[0].id;
        $("#disclosureDiscussionGrid").data("kendoGrid").dataSource.read();
    }

    discussionDataBound(e) {
        const gridId = e.sender.element[0].id;
        const grid = $("#" + gridId).data("kendoGrid");
        const data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            const trow = grid.tbody.find("tr[data-uid='" + data[i].uid + "']");
            if (!data[i].CanDelete) {
                trow.find(".k-grid-delete").hide();
            }
            else if (data[i].CanDelete && data[i].CanEditRecord) {
                trow.find(".k-grid-delete").show();
            }
            else {
                trow.find(".k-grid-delete").hide();
            }

            if (!data[i].CanEdit) {
                trow.find(".k-grid-edit").hide();
            }
            else if (data[i].CanEdit && data[i].CanEditRecord) {
                trow.find(".k-grid-edit").show();
            }
            else {
                trow.find(".k-grid-edit").hide();
            }
        }
    }

    onDiscussionEdit(e) {
        var arg = e;
        arg.container.data('kendoWindow').bind('activate', function () {
            arg.container.find("textarea[name='DiscussionMsg']").focus();
        })
    }

    onDiscussionRequestEnd(e) {
        //type: create, update, destroy
        //if type is create - check workflow for new discussion
        if (e.type === "create") {
            disclosurePage.checkDisclosureWorkflow(e.response.dmsId, "discussion");
        }
    }

    replyRequestEnd(e) {
        if (e.type == "destroy") {
            $("#disclosureDiscussionGrid").data("kendoGrid").dataSource.read();
        }
        if (e.type === "create") {
            disclosurePage.checkDisclosureWorkflow(e.response.dmsId, "reply");
        }
    }

    // ---------------------------- workflow
    checkDisclosureWorkflow(id, triggerType) {
        let mainForm = $(`#${this.mainDetailContainer}`).find("form")[0];
        mainForm = $(mainForm);
        const url = mainForm.data("check-workflow");
        const data = { dmsId: id, triggerType: triggerType };
        $.ajax({
            url: url,
            data: data,
            type: "POST",
            headers: { "RequestVerificationToken": $("[name='__RequestVerificationToken']").val() },
            success: function (result) {
                if (result.qeSetupIds && result.sendEmail) {
                    var qeSetupIds = JSON.parse(result.qeSetupIds);

                    if (qeSetupIds.length > 0) {
                        let promise = disclosurePage.sendQuickEmail(data.dmsId, !qeSetupIds[0].Item2, "auto-email-url", qeSetupIds[0].Item1, !qeSetupIds[0].Item2, qeSetupIds[0].Item3, qeSetupIds[0].Item4);

                        for (let i = 1; i < qeSetupIds.length; i++) {
                            const qeSetupId = qeSetupIds[i];
                            promise = promise.then(function () {
                                return disclosurePage.sendQuickEmail(data.dmsId, !qeSetupId.Item2, "auto-email-url", qeSetupId.Item1, !qeSetupId.Item2, qeSetupIds.Item3, qeSetupIds.Item4);
                            });
                        }
                    }
                }
            },
            error: function (error) {
                pageHelper.showErrors(error.responseText);
            }
        });
    }

    sendQuickEmail(dmsId, isAutoEmail, urlName, qeSetupId, sendImmediately, includeAttachments, quickEmailOptOutSetting) {
        const deferred = $.Deferred();

        const parent = $("#disclosureParameters");
        const url = parent.data(urlName);
        const data = { dmsId: dmsId, qeSetupId: qeSetupId, sendImmediately: sendImmediately, includeAttachments: includeAttachments, quickEmailOptOutSetting: quickEmailOptOutSetting };

        $.ajax({
            url: url,
            type: "GET",
            data: data,
            success: function (result) {
                if (!isAutoEmail) {
                    const popupContainer = $(".cpiContainerPopup").last();
                    popupContainer.html(result);
                    const dialog = $("#quickEmailDialog");
                    dialog.modal("show");                    
                    dialog.find("#ok, #cancel,.close").on("click", () => { $(".modal-backdrop").remove(); deferred.resolve(); });
                }
                else {
                    deferred.resolve();
                    //pageHelper.showSuccess(result.success);
                }
            },
            error: function (error) {
                pageHelper.showErrors(error);
                deferred.resolve();
            }
        });
        return deferred.promise();
    }

    //sendQuickEmail(dmsId, isAutoEmail, urlName, qeSetupId, sendImmediately) {
    //    const parent = $("#disclosureParameters");        
    //    const url = parent.data(urlName);
    //    const data = { dmsId: dmsId, qeSetupId: qeSetupId, sendImmediately: sendImmediately };
    //    $.ajax({
    //        url: url,
    //        type: "GET",
    //        data: data,
    //        success: function (result) {
    //            if (!isAutoEmail) {
    //                const popupContainer = $(".cpiContainerPopup").last();
    //                popupContainer.html(result);
    //                const dialog = $("#quickEmailDialog");                
    //                dialog.modal("show"); 

    //                //dialog.on('hidden.bs.modal', function (event) {
    //                //    myResolve(true);                           
    //                //});  
    //            }
    //            else {
    //                //pageHelper.showSuccess(result.success);
    //            }
    //        },
    //        error: function (error) {
    //            pageHelper.showErrors(error);
    //        }
    //    });
    //}

    //------------------------------------------------------------ COPY
    showCopyScreen() {
        //const popupContainer = $(".cpiContainerPopup").last();
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#disclosureCopyDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            const dataContainer = $('#' + self.mainDetailContainer).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }

    mainCopyInitialize = (copyDMSId) => {
        const baseUrl = $("body").data("base-url");
        const mainUrl = `${baseUrl}/DMS/Disclosure`;

        $(document).ready(() => {

            const container = $("#disclosureCopyDialog");
            container.find(".case-info-settings").hide();

            container.on("click", ".case-info-set", () => {
                container.find(".case-info-settings").show();
                container.find(".data-to-copy").hide();

                const url = `${mainUrl}/GetCopySettings`;
                $.get(url, { copyDMSId: copyDMSId })
                    .done(function (result) {
                        container.find(".case-info-settings-fields").html(result);
                    })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
            container.on("click", ".case-info-set-cancel,.case-info-set-save", () => {
                container.find(".case-info-settings").hide();
                container.find(".data-to-copy").show();
            });
            container.on("change", ".case-info-settings-fields input[type='checkbox']", function () {
                const checkbox = $(this);
                const name = checkbox.attr("name");
                const value = checkbox.prop("checked");
                const url = `${mainUrl}/UpdateCopySetting`;
                $.post(url, { copySettingId: name, copy: value })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });

            //get all questions by default
            let questions = "|";
            const questionDiv = $(".dmsQuestions");
            $(questionDiv.find("input")).each(function () {
                const questionName = $(this).attr("name");
                if (this.checked && questionName !== undefined) {
                    questions += questionName + "|";
                }
            });
            $("#copiedQuestionList").val(questions);
            //get copied questions
            container.on("change", ".dmsQuestions input[type='checkbox']", function () {
                let questions = "|";
                const questionDiv = $(".dmsQuestions");
                $(questionDiv.find("input")).each(function () {
                    const questionName = $(this).attr("name");
                    if (this.checked && questionName !== undefined) {
                        questions += questionName + "|";
                    }
                });
                $("#copiedQuestionList").val(questions);
            });

        });
    }

    /* related disclosure */
    onChange_RelatedDisclosure = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");

            const disclosureTitle = e.dataItem["DisclosureTitle"];
            const disclosureStatus = e.dataItem["DisclosureStatus"];
            const disclosureDate = e.dataItem["DisclosureDate"];

            const grid = $("#disclosureRelatedDisclosuresGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.RelatedDMSId = e.dataItem["DMSId"];
            dataItem.DisclosureTitle = disclosureTitle;
            dataItem.DisclosureStatus = disclosureStatus;
            dataItem.DisclosureDate = disclosureDate;

            $(row).find(".title-field").html(disclosureTitle);
            $(row).find(".status-field").html(disclosureStatus);
            $(row).find(".date-field").html(disclosureDate);
        }
    }

    onDueDateAttorneyChange = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
            const dataItem = grid.dataItem(row);

            dataItem.AttorneyID = e.dataItem["AttorneyID"];
        }
    }

    clearDueDateAttorney = (e) => {
        const row = $(`#${e.sender.element[0].id}`).closest("tr");
        const grid = $(`#actionsGrid_${this.mainDetailContainer}`).data("kendoGrid");
        const dataItem = grid.dataItem(row);

        if (dataItem.DueDateAttorneyName == null || dataItem.DueDateAttorneyName == "") {
            dataItem.AttorneyID = null;
            dataItem.DueDateAttorneyName == "";
        }
    }

    /* Copy to Patent Clearance*/
    setCopyClearanceButton() {
        const button = $("#copyToClearanceDisclosure");
        const self = this;
        if (button) {
            button.on("click", function (e) {
                const url = button.data("url");
                cpiLoadingSpinner.show();
                $.get(url)
                    .done(function (response) {
                        const popupContainer = $(".site-content .popup");
                        popupContainer.empty();
                        popupContainer.html(response);
                        var dialog = $("#disclosureCopyClearanceDialog");
                        dialog.modal("show");
                        cpiLoadingSpinner.hide();
                    })
                    .fail(function (error) {
                        cpiLoadingSpinner.hide();
                        pageHelper.showErrors(error);
                    });                
                return false;
            });
        }
    }

    showCopyClearanceScreen() {        
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#disclosureCopyClearanceDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            if (result) {
                pageHelper.showSuccess(result.success.Name);          
            }            
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }

    mainCopyClearanceInitialize = (copyDMSId) => {
        const baseUrl = $("body").data("base-url");
        const mainUrl = `${baseUrl}/DMS/Disclosure`;

        $(document).ready(() => {

            const container = $("#disclosureCopyClearanceDialog");
            container.find(".case-info-settings").hide();

            container.on("click", ".case-info-set", () => {
                container.find(".case-info-settings").show();
                container.find(".data-to-copy").hide();

                const url = `${mainUrl}/GetCopyClearanceSettings`;
                $.get(url, { copyDMSId: copyDMSId })
                    .done(function (result) {
                        container.find(".case-info-settings-fields").html(result);
                    })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });
            container.on("click", ".case-info-set-cancel,.case-info-set-save", () => {
                container.find(".case-info-settings").hide();
                container.find(".data-to-copy").show();
            });
            container.on("change", ".case-info-settings-fields input[type='checkbox']", function () {
                const checkbox = $(this);
                const name = checkbox.attr("name");
                const value = checkbox.prop("checked");
                const url = `${mainUrl}/UpdateCopyClearanceSetting`;
                $.post(url, { copySettingId: name, copy: value })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });

            ////get all questions by default
            //let questions = "|";
            //const questionDiv = $(".dmsQuestions");
            //$(questionDiv.find("input")).each(function () {
            //    const questionName = $(this).attr("name");
            //    if (this.checked && questionName !== undefined) {
            //        questions += questionName + "|";
            //    }
            //});
            //$("#copiedQuestionList").val(questions);
            ////get copied questions
            //container.on("change", ".dmsQuestions input[type='checkbox']", function () {
            //    let questions = "|";
            //    const questionDiv = $(".dmsQuestions");
            //    $(questionDiv.find("input")).each(function () {
            //        const questionName = $(this).attr("name");
            //        if (this.checked && questionName !== undefined) {
            //            questions += questionName + "|";
            //        }
            //    });
            //    $("#copiedQuestionList").val(questions);
            //});

        });
    }

    showDueDateEmailScreen(e, grid) {
        const form = $("#" + this.detailContentContainer).find("form");
        const url = form.data("duedate-email-url");
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const ddId = dataItem.DDId;

        $.ajax({
            url: url,
            data: { id: ddId },
            success: function (result) {
                var popupContainer = $(".cpiContainerPopup").last();
                popupContainer.html(result);
            },
            error: function (e) {
                pageHelper.showErrors(e);
            }
        });
    }

    showAverageRating = (screen, title, id, score) => {
        const container = $(`#${screen}`).find(".cpiButtonsDetail");
        const pageNav = container.find(".nav");         
        pageNav.prepend(`<a class="nav-link" href="#" style="pointer-events: none; cursor: default;" title="${title}" role="button"><span class='tickler-patent-score badge'>${score}</span></a>`);
    }

    //TN 20221116
    onChange_Product = (e) => {
        if (e.sender) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#productsGrid_dmsDiclosureDetail").data("kendoGrid");
            const dataItem = grid.dataItem(row);

            var comboDataItem = e.sender.dataItem();
            dataItem.ProductId = comboDataItem["ProductId"];
            dataItem.ProductName = comboDataItem["ProductName"];

        }
    }

    onChange_Component = (e) => {
        if (e.sender) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#componentsGrid_dmsDiclosureDetail").data("kendoGrid");
            const dataItem = grid.dataItem(row);

            var comboDataItem = e.sender.dataItem();
            dataItem.ComponentID = comboDataItem["ComponentID"];
            dataItem.Component = comboDataItem["Component"];

        }
    }
    //TN 20221116
}


